import { customElement, property, state } from 'lit/decorators.js';
import type { Callback, Unsubscribe } from '@common/lit/store/state.js';
import { BaseComponent } from '@src/components/BaseComponent.js';
import { DEFAULT_MSISDN_FILTER } from '@src/store/ConsentStore.js';
import { consentStore } from '@src/store/index.js';

@customElement('tef-coms-button')
export class TefComsButton extends BaseComponent {
  @property({ type: String }) text : string = 'Default Button Text';
  @state() disabled : boolean = false;

  unsubscribe : Unsubscribe;

  constructor() {
    super();
    this.unsubscribe = consentStore.subscribe(this.handleChosenMsisdnUpdate.bind(this) as Callback, ['chosenMsisdn']);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.unsubscribe();
  }

  handleChosenMsisdnUpdate() {
    if (consentStore.chosenMsisdn !== DEFAULT_MSISDN_FILTER) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }

  override render() {
    return this.getTemplateFn('tefComsButton')();
  }

  handleClick(event: PointerEvent) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }

  // Render into lightDOM
  protected createRenderRoot() {
    return this;
  }
}
